import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthClient } from '../auth/AuthClient';
import { useAuth } from '../hooks/useAuth';
const ProtectedRoute = ({ children, requiredActions = [] }) => {
    const { isAuthenticated, isLoading, user, login, state, error } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (!isLoading && !isAuthenticated && state.status !== 'error') {
            sessionStorage.setItem('auth_return_to', location.pathname);
            login();
        }
    }, [isAuthenticated, isLoading, location.pathname, login, state.status]);
    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            const returnTo = AuthClient.consumePendingReturnTo();
            if (returnTo) {
                void navigate(returnTo, { replace: true });
            }
        }
    }, [isAuthenticated, isLoading, navigate]);
    if (isLoading) {
        return (_jsx("div", { style: { padding: '20px', textAlign: 'center' }, children: _jsx("p", { children: "Loading..." }) }));
    }
    if (state.status === 'error') {
        return (_jsxs("div", { style: { padding: '20px', textAlign: 'center' }, children: [_jsx("h2", { children: "Authentication Error" }), _jsx("p", { children: error }), _jsx("button", { onClick: () => login(), children: "Retry Login" })] }));
    }
    if (!isAuthenticated) {
        return null;
    }
    if (requiredActions.length > 0 && user) {
        const hasPermission = requiredActions.every((action) => user.actions.includes(action));
        if (!hasPermission) {
            return (_jsxs("div", { style: { padding: '20px', textAlign: 'center' }, children: [_jsx("h2", { children: "Unauthorized" }), _jsx("p", { children: "You do not have permission to access this page." }), _jsxs("p", { children: ["Required permissions: ", requiredActions.join(', ')] }), _jsxs("p", { children: ["Your role: ", user.role] })] }));
        }
    }
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
